import { str } from "@lit/localize";
//#region src/generated/locales/be.ts
var templates = {
	"pd.wizard.button.back": `Terug`,
	"pd.wizard.button.next": `Volgende`,
	"pd.wizard.button.send": `Verzenden`,
	"pd.wizard.close.aria": `Wizard sluiten`,
	"pdWizard.close.popup.cancel": `Annuleren`,
	"pdWizard.close.popup.noStorage.content": `De huidige invoer gaat na het sluiten onherroepelijk verloren. Toch sluiten?`,
	"pdWizard.close.popup.ok": `Sluiten`,
	"pdWizard.close.popup.storage.content": `De huidige invoer kan worden opgeslagen voor latere bewerking of worden verwijderd. Welke actie moet worden uitgevoerd?`,
	"pdWizard.close.popup.title": `Bewerking annuleren`,
	"pdWizard.reload.popup.cancel": `Verwijderen`,
	"pdWizard.reload.popup.lastModified": `Laatst bewerkt:`,
	"pdWizard.reload.popup.ok": `Voortzetten`,
	"pdWizard.reload.popup.title": `Bewerking voortzetten?`,
	"pdWizard.storage.close.popup.cancel": `Verwijderen`,
	"pdWizard.storage.close.popup.ok": `Opslaan`,
	"pd.steps.aria.label": `Wizard-Schritte`,
	"pd.steps.aria.passed": str`Schritt ${0}: ${1} - abgeschlossen, klicken um zurückzukehren`,
	"pd.steps.aria.current": str`Schritt ${0}: ${1} - aktueller Schritt`,
	"pd.steps.aria.pending": str`Schritt ${0}: ${1} - ausstehend`,
	"pd.wizard.button.cancel": `Abbrechen`,
	"pdWizard.reload.popup.warning": `Bei Neubeginn werden die Daten gelöscht`
};
//#endregion
export { templates };
